export default {"src":"/_next/static/media/godrej.6de4d498.svg","height":161,"width":345,"blurWidth":0,"blurHeight":0};